import type { ReactNode } from 'react';

import { subscriptionFormOptions } from '@/entities/(notification)/subscription';
import { withForm } from '@/shared/ui/form';

import { SubscriptionActionSection } from './subscription-action-section';
import { SubscriptionTriggerSection } from './subscription-trigger-section';

export const SubscriptionFormPanel = withForm({
  ...subscriptionFormOptions,
  props: {
    workspaceId: '',
    renderFooter: undefined as (() => ReactNode) | undefined,
  },
  render: ({ form, workspaceId, renderFooter }) => {
    return (
      <div className="flex flex-1 flex-col gap-5 max-w-[1400px]">
        {/* Details 섹션 */}
        <div className="flex flex-col gap-5 rounded-lg border p-5">
          <span className="text-sm font-semibold">Details</span>
          <div className="grid grid-cols-[120px_1fr] items-start gap-3">
            <span className="pt-2 text-sm text-muted-foreground">Title</span>
            <form.AppField
              name="title"
              validators={{
                onChange: ({ value }) => {
                  if (!value) return 'Please enter a title';
                  return undefined;
                },
                onSubmit: ({ value }) => {
                  if (!value) return 'Please enter a title';
                  return undefined;
                },
              }}
              children={(field) => (
                <field.TextField placeholder="Enter title..." />
              )}
            />
          </div>
        </div>

        <SubscriptionTriggerSection form={form} />
        <SubscriptionActionSection form={form} workspaceId={workspaceId} />
        {renderFooter?.()}
      </div>
    );
  },
});
